import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { useNavigate } from 'react-router-dom';
import { FileText, Trash2 } from 'lucide-react';

export default function AdminChildrenTab({ allChildren, onDeleteChild }) {
  const navigate = useNavigate();

  return (
    <div data-testid="admin-children-tab">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-xl font-bold text-slate-800" style={{ fontFamily: 'Nunito' }}>All Children</h2>
        <Badge variant="outline" className="rounded-full">{allChildren.length} total</Badge>
      </div>
      <div className="space-y-3">
        {allChildren.map(c => (
          <Card key={c.child_id} className="rounded-2xl border-slate-100 shadow-sm" data-testid={`child-card-${c.child_id}`}>
            <CardContent className="p-4 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
              <div className="flex items-center gap-3 flex-1 cursor-pointer" onClick={() => navigate(`/dashboard/admin/child/${c.child_id}`)}>
                <div className="w-10 h-10 rounded-xl bg-[#ECFEFF] flex items-center justify-center text-[#0E7490] font-bold shrink-0" style={{ fontFamily: 'Nunito' }}>{c.name?.charAt(0) || '?'}</div>
                <div>
                  <p className="font-semibold text-slate-700 text-sm">{c.name || 'Unnamed'}</p>
                  <div className="flex flex-wrap gap-x-3 gap-y-0.5 text-xs text-slate-400">
                    {c.instructor_name && <span>Instructor: {c.instructor_name}</span>}
                    {c.parent_name && <span>Parent: {c.parent_name}</span>}
                    <span>{c.session_count || 0} sessions</span>
                  </div>
                </div>
              </div>
              <div className="flex gap-2">
                <Button size="sm" variant="outline" className="rounded-xl text-xs font-semibold gap-1" onClick={() => navigate(`/dashboard/admin/child/${c.child_id}`)} data-testid={`view-child-${c.child_id}`}>
                  <FileText className="w-3 h-3" /> View
                </Button>
                <Button size="sm" variant="outline" className="rounded-xl text-xs font-semibold gap-1 text-red-500 border-red-200 hover:bg-red-50" onClick={() => onDeleteChild(c)} data-testid={`delete-child-${c.child_id}`}>
                  <Trash2 className="w-3 h-3" /> Delete
                </Button>
              </div>
            </CardContent>
          </Card>
        ))}
        {allChildren.length === 0 && <p className="text-center text-slate-400 py-8">No children in the system</p>}
      </div>
    </div>
  );
}
